import moment from 'moment';

import { DATE_TIME_FORMAT } from '../../utilities/constants';
import { isNullOrUndefinedOrEmptyStr } from '../../utilities/stringUtil';

/**
 * 実績集計一覧検索パラメータ作成
 * @param {object} param 検索パラメーター
 * @returns {object} API通信用検索パラメーター
 * */
const createSearchApiParam = ({
  fromDate,
  toDate,
  isUnfulfillRate,
  offset,
}) => {
  const dateFormat = DATE_TIME_FORMAT.slashDateFormat;
  const searchParam = Object.create(null);
  searchParam.offset = offset || 0;
  searchParam.from_date = moment(fromDate).format(dateFormat);
  searchParam.to_date = moment(toDate).format(dateFormat);
  searchParam.is_unfulfill_rate = isUnfulfillRate || 0;
  return searchParam;
};

/**
 * 常傭と請負のデータのフォーマット
 * @param {string} regular 常傭
 * @param {string} contract 請負
 * @returns 合計(常傭/請負)
 */
const buildCellString = (regular, contract) => {
  if (
    isNullOrUndefinedOrEmptyStr(regular) &&
    isNullOrUndefinedOrEmptyStr(contract)
  ) {
    return null;
  }
  regular = regular || '0.0';
  contract = contract || '0.0';
  const sum = parseFloat(regular) + parseFloat(contract);
  return `${formatFloat(sum)} (${regular} / ${contract})`;
};

/**
 * floatのフォーマット
 * @example
 * // returns 1.0
 * formatFloat(1)
 * @example
 * // returns 1.2
 * formatFloat(1.2)
 * @example
 * // returns 1.25
 * formatFloat(1.25)
 * @param {number} value
 */
const formatFloat = value => {
  const rawString = parseFloat(value.toFixed(2)).toString();
  const decimalPart = rawString.split('.')[1];
  const decimalPartLength = decimalPart ? decimalPart.length : 1;
  return value.toFixed(decimalPartLength);
};

/**
 * 入場人数との差異で利用するビジネスロジック格納クラス
 * */
const FieldTreeResultService = {
  createSearchApiParam,
  buildCellString,
};

export default FieldTreeResultService;



// WEBPACK FOOTER //
// ./src/services/fieldTreeResult/FieldTreeResultService.js